import { CommonConstants } from "utils/constants";

const UnitsHelper = {
  getTextWithSuffix: (text: string, suffix: string) => {
    return `${text}${suffix}`;
  },
  getTimeWithHoursSuffix: (text: string) => {
    return UnitsHelper.getTextWithSuffix(text, `${CommonConstants.HoursSymbol}`);
  },
};
export default UnitsHelper;
